import { strings as stringManager } from '../../Strings';
export const moduleName = 'performanceRatingCard';
stringManager.load(moduleName, {
    cardTitle: 'Performance',
    descriptionPrefix: '{0} demonstrates a performance of',
    descriptionSuffix: 'within your company\'s scale.',
    thisEmployee: 'This employee'
});
const moduleStrings = stringManager[moduleName];
export { moduleStrings as strings };
export default moduleStrings;
